import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {newsletterSegmentEdit_template} from "../components/templates/newsletterSegmentEdit_template";
import {downloadTargetedEmailCsv} from "../utils/TargetedEmailCsvExporter";

declare var ko: any;
declare var page: any;

export class newsletter_segment_edit extends vnModule_knockoutJS {
    protected segmentEdit: newsletterSegmentEdit_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.segmentEdit = new newsletterSegmentEdit_template("newsletterSegmentEdit", this.viewModel, this);
        return [this.segmentEdit.build()];
    }

    protected getModuleName(): string {
        return "newsletter_segment_edit";
    }

    fillPage(): void {
        this.getReferences();
    }

    protected getReferences(): void {
        this.loadingIn(this.segmentEdit.builtTemplate);
        let url = '/api/brand/' + this.getBrandId() + '/newsletter/segments/references/';
        this.XHRHdl = new XMLHttpRequestHandler(url, [], this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesReturn;
        this.XHRHdl.execute();
    }

    protected onReferencesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.segmentEdit.setReferences(responseParsed);
                obj.getSegment();
            });
            obj.loadingOut(obj.segmentEdit.builtTemplate);
        };
    }

    protected getSegment(): void {
        let id = this.getVnAppZone().app.params.id;
        if (!id) {
            this.segmentEdit.setSegment({
                id: '',
                title: '',
                isActive: true,
                criteria: null
            });
            return;
        }

        let url = '/api/brand/' + this.getBrandId() + '/newsletter/segments/get/' + id + '/';
        this.XHRHdl = new XMLHttpRequestHandler(url, [], this);
        this.XHRHdl.onReadyStateFunction = this.onSegmentReturn;
        this.XHRHdl.execute();
    }

    protected onSegmentReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.segmentEdit.setSegment(responseParsed.segment);
            });
        };
    }

    public save(): void {
        this.loadingIn(this.segmentEdit.builtTemplate);
        let url = '/api/brand/' + this.getBrandId() + '/newsletter/segments/save/';
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.segmentEdit.getViewModelForRequest())]);

        let XHRHdl = new XMLHttpRequestHandler(url, params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveReturn;
        XHRHdl.execute();
    }

    protected onSaveReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Newsletter segment saved.");
                page.redirect('/brand/' + obj.getBrandId() + '/newsletter/segments/');
            });
            obj.loadingOut(obj.segmentEdit.builtTemplate);
        };
    }

    public preview(): void {
        this.segmentEdit.setPreviewLoading(true);
        this.postCriteriaTool('/preview/', this.segmentEdit.getPreviewRequest(), (responseParsed) => {
            this.segmentEdit.setPreviewCount(responseParsed.count);
        }, () => {
            this.segmentEdit.setPreviewLoading(false);
        });
    }

    public loadProfileOptions(field: string, callback: Function): void {
        let url = '/api/brand/' + this.getBrandId() + '/newsletter/segments/autocomplete/?field=' + encodeURIComponent(field);
        let XHRHdl = new XMLHttpRequestHandler(url, [], this);
        XHRHdl.onReadyStateFunction = (req, obj) => () => {
            obj.manageResponse(req, obj, () => callback(JSON.parse(req.request.response).data || []));
        };
        XHRHdl.execute();
    }

    public exportAudience(): void {
        this.segmentEdit.setExportLoading(true);
        this.postCriteriaTool('/export/', this.segmentEdit.getPreviewRequest(), (responseParsed) => {
            downloadTargetedEmailCsv(responseParsed.emails || [], 'newsletter-segment-targeted-emails.csv');
        }, () => {
            this.segmentEdit.setExportLoading(false);
        });
    }

    public lookup(): void {
        let request = this.segmentEdit.getLookupRequest();
        this.segmentEdit.setLookupLoading(true);
        this.postCriteriaTool('/lookup/', request, (responseParsed) => {
            this.segmentEdit.setLookupResult(responseParsed.results || [{
                email: responseParsed.email,
                matches: responseParsed.matches
            }]);
        }, () => {
            this.segmentEdit.setLookupLoading(false);
        });
    }

    protected postCriteriaTool(action: string, data: any, callback: Function, onComplete: Function): void {
        let url = '/api/brand/' + this.getBrandId() + '/newsletter/segments' + action;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(data)]);
        let XHRHdl = new XMLHttpRequestHandler(url, params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = function (req, obj) {
            return function () {
                if (req.request.readyState !== 4) {
                    return;
                }
                try {
                    obj.manageResponse(req, obj, function () {
                        callback(JSON.parse(req.request.response));
                    });
                } finally {
                    onComplete();
                }
            };
        };
        XHRHdl.execute();
    }

    public cancelForm(): void {
        page.redirect('/brand/' + this.getBrandId() + '/newsletter/segments/');
    }

    public edit(): void {
        page.redirect('/brand/' + this.getBrandId() + '/newsletter/segments/edit/' + this.getVnAppZone().app.params.id + '/');
    }

    public getBrandId(): string {
        return this.getVnAppZone().app.params.idBrand;
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_segment_edit.ts